export const TRAVELER_INFO_TITLE = "Step 1. Traveler information";
export const NO_TRAVELERS_TITLE = "To select a traveler for this age group, add a new one.";
export const TRAVELER_INFO_TITLE_UPDATED = (searchedTravelerCount: number) =>
  `Select or add (${searchedTravelerCount}) ${
    searchedTravelerCount === 1 ? "traveler" : "travelers"
  }`;
export const ADDITIONAL_INFO_TITLE = "Additional information";
export const ADDITIONAL_INFO_SUBTITLE =
  "This activity operator requires travelers to include additional information for safety measures.";
export const ADULT_TITLE = "Adult";
export const CHILD_TITLE = "Child";
export const UPDATE_TEXT = "Updating passengers";
export const VALIDATE_TEXT = "Validating passengers";
export const ADD_TRAVELERS_TEXT = "Add travelers";
export const ADD_TRAVELERS_TEXT_UPDATED = "Add new traveler";
export const EDIT_TRAVELER_TEXT = "Edit traveler";
export const ADD_TRAVELERS_SUBTITLE =
  "Ensure all information matches your travel ID. You can't change this information once you place a booking.";
export const ADD_TRAVELER_INFO_TEXT = "Add traveler information";
export const TRAVELER_INFO_TEXT = "Traveler information";
export const ADD_TRAVELER_ERROR_MESSAGE =
  "Add or choose at least one traveler to continue.";
export const PASSPORT_TITLE = "Passport details";
export const PASSPORT_SUBTITLE =
  "This activity operator requires travelers to include passport details.";
export const REQUIRED_FIELD = "Required field";

export const WEIGHT_LBS_LABEL = "Weight (lb)";
export const HEIGHT_FT_LABEL = "Height (ft)";
export const HEIGHT_IN_LABEL = "Height (in)";

export const WEIGHT_INVALID = "Please enter a valid weight between 1 and 1000 lbs";
export const HEIGHT_FT_INVALID = "Please enter a valid height between 0 and 8 feet";
export const HEIGHT_IN_INVALID = "Please enter a valid height between 0 and 11 inches";
export const PASSPORT_NUMBER_INVALID = "Please enter a valid passport number (6-9 characters)";
export const PASSPORT_COUNTRY_REQUIRED = "Country of issue is required";
export const PASSPORT_EXPIRATION_REQUIRED = "Expiration date is required";
export const PASSPORT_EXPIRATION_INVALID = "Passport must not be expired";

// corporate
export const COMPLETE_PROFILE_TITLE = "Complete traveler profile";
export const COMPLETE_PROFILE_SUBTITLE =
  "Please make sure all the information added matches the government issued ID for this traveler as this will be applied to travel bookings moving forward. Traveler information will be accessible to all Admins.";
